import { DealQuestionnaireSettings, DealStage } from "@/pages/deals/types";

export const getQuestionnaireIds = (
  settings: DealQuestionnaireSettings
): string[] => {
  const allQuestionnaires = Object.values(settings).flatMap(
    (stageSettings) => stageSettings?.data?.questionnaires ?? []
  );
  const uniqueIds = [...new Set(allQuestionnaires.map((q) => q?.id))];
  return uniqueIds;
};

export const getStagesUpToCurrent = (
  currentStage: DealStage | undefined,
  allStages?: DealStage[]
) => {
  if (!currentStage || !allStages) return [];
  const stageIds: number[] = [];
  for (let order = 1; order <= currentStage.stageOrder; order++) {
    const stage = allStages.find((s) => s.stageOrder === order);
    if (stage) {
      stageIds.push(stage.id);
    }
  }
  return stageIds;
};
